import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DocumenteService {
    private basePath = environment.basePath;

    private getSimboluriUrl = this.basePath + environment.routes.ddru.documente.getSimboluri;
    private checkIdentificareUrl = this.basePath + environment.routes.ddru.documente.checkIdentificare;
    private checkTokenUrl = this.basePath + environment.routes.ddru.documente.checkToken;
    private confirmOtpUrl = this.basePath + environment.routes.ddru.documente.confirmOtp;
    private resendOtpUrl = this.basePath + environment.routes.ddru.documente.resendOtp;
    private downloadDocumentUrl = this.basePath + environment.routes.ddru.documente.downloadDocument;

    constructor(private http: HttpClient) { }

    getSimboluri(simbol: string) {
        let params = new HttpParams().set('name', simbol);

        return this.http.get(this.getSimboluriUrl, { params });
    }

    checkIdentificare(payload: any) {
        return this.http.post(this.checkIdentificareUrl, payload);
    }

    checkToken(token: string) {
        let params = new HttpParams().set('t', token);

        return this.http.get(this.checkTokenUrl, { params });
    }

    confirmOtp(payload: any) {
        return this.http.post(this.confirmOtpUrl, payload);
    }

    resendOtp(payload: any) {
        return this.http.post(this.resendOtpUrl, payload);
    }

    downloadDocument(payload: any): Observable<Blob> {
        return this.http.post(this.downloadDocumentUrl, payload, {
            responseType: 'blob'
        });
    }
}
